export const jsCssReactGql = [
  "Lenguajes Usados",
  "JavaScript",
  "CSS",
  "React",
  "GraphQL",
];
export const jsCssReactBts = [
  "Lenguajes Usados",
  "JavaScript",
  "CSS",
  "React",
  "Bootstrap",
];

export const jsCssTailwindReact = [
  "Lenguajes Usados",
  "JavaScript",
  "CSS",
  "Tailwind",
  "React",
];
export const jsCssTailwindReactFirebase = [
  "Lenguajes Usados",
  "JavaScript",
  "CSS",
  "Tailwind",
  "React",
  "Firebase",
];
export const ecommerceLanguajes = ["Lenguajes Usados", "Tailwind", "Next", "Zustand", "Zod"];

export const jsvanillaCss = ["Lenguajes Usados", "JavaScript vanilla", "CSS"];

export const jsVanillaCssFirebase = [
  "Lenguajes Usados",
  "JavaScript vanilla",
  "CSS",
  "Firebase",
];

export const jsReactCss = ["Lenguajes Usados", "JavaScript", "CSS", "React"];

export const paymentAppLanguages = ["Lenguajes Usados", "Tailwind", "React", "Zustand", "Zod"]

export const angularAppLanguajes = ["Lenguajes Usados", "JavaScript", "CSS", "Angular"];
export const vueAppLanguajes = ["Lenguajes Usados", "JavaScript", "CSS", "Vue.js"];